<template>
  <div class="homebox">
    <!-- Banner 区域 -->
    <div class="banner-wrapper">
      <img
        v-if="banner && footer.trim() !== ''"
        :src="banner"
        class="banner"
        alt="Banner"
        @load="bannerLoaded = true"
        :class="{ loaded: bannerLoaded }"
      />
      <img
        v-if="banner && !bannerLoaded"
        src="/loading.gif"
        class="banner placeholder"
        alt="加载中"
      />
    </div>
    
    <!-- 商品列表 -->
    <div>
      <h2 class="title">{{ title }}</h2>
    </div>
    <ul>
      <li v-for="product in products" :key="product.id">
        <router-link :to="`/product/${product.id}`">
          <div class="img-wrapper">
            <img 
              :src="product.image" 
              :alt="product.name"
              @load="onProductLoad(product.id)"
              :class="{ loaded: loadedImages[product.id] }"
            />
            <img
              v-if="!loadedImages[product.id]"
              src="/loading.gif"
              class="placeholder"
              alt="加载中"
            />
          </div>
          <h4>{{ product.title }}</h4>
        </router-link>
      </li>
    </ul>
    
    <!-- 底部 Banner -->
    <div class="banner2-wrapper">
      <h2 class="title">{{ title2 }}</h2>
      <img
        v-if="footer && footer.trim() !== ''"
        :src="footer"
        class="banner2"
        alt="Banner"
        @load="footerLoaded = true"
        :class="{ loaded: footerLoaded }"
      />
      <img
        v-if="footer && !footerLoaded"
        src="/loading.gif"
        class="banner2 placeholder"
        alt="加载中"
      />
    </div>
  </div>
</template>

<script>
import { productsList, getSettings } from "@/api/product/index";

export default {
  name: "contentHome",
  data() {
    return {
      products: [],
      total: 0,
      pageSize: 20,
      currentPage: 1,
      banner: "",
      footer: "",
      title: "",
      title2: "",
      showPreview: false,
      bannerLoaded: false,
      footerLoaded: false,
      loadedImages: {},
    };
  },
  created() {
    this.fetchProducts();
    this.getData();
  },
  methods: {
    onProductLoad(productId) {
      this.$set(this.loadedImages, productId, true);
    },
    previewImage() {
      this.$imgPreview({
        url: this.footer,
      })
    },
    async getData() {
      const res = await getSettings();

      console.log("接口返回数据：", res);

      if (res.status === 200) {
        const data = res.data;

        console.log("banner_img：", data.banner_img);
        console.log("footer_img：", data.footer_img);

        this.banner = data.banner_img;
        this.footer = data.footer_img;
        this.title = data.title || "";
        this.title2 = data.title2 || "";
      }
    },
    async fetchProducts() {
      try {
        const response = await productsList(this.currentPage, this.pageSize, 1);

        console.log("response", response);

        if (response && response.status === 200) {
          this.products = response.data || [];
          this.total = response.total || 0;
        } else {
          console.error("获取商品列表失败");
          this.products = [];
          this.total = 0;
        }
      } catch (error) {
        console.error("获取商品列表失败:", error);
        this.products = [];
        this.total = 0;
      }
    },
  },
};
</script>

<style scoped>
/* 图片包装器 - 相对定位，用于放置占位符 */
.img-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
}

.banner-wrapper,
.banner2-wrapper {
  position: relative;
}

/* 真实图片样式 - 初始透明，加载完成后显示 */
.img-wrapper img:not(.placeholder),
.banner:not(.placeholder),
.banner2:not(.placeholder) {
  opacity: 0;
  transition: opacity 0.3s ease;
  position: relative;
  z-index: 1;
}

.img-wrapper img.loaded,
.banner.loaded,
.banner2.loaded {
  opacity: 1;
}

/* 占位符样式 - 覆盖在相同位置 */
.placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

/* 确保 banner 和 banner2 的占位符正确定位 */
.banner-wrapper .placeholder,
.banner2-wrapper .placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}

/* 其余样式保持不变 */
.image-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: pointer;
}

.preview-image {
  max-width: 90%;
  max-height: 90%;
  object-fit: contain;
  cursor: default;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 36px;
  color: white;
  cursor: pointer;
  font-weight: bold;
  z-index: 10000;
}

.close-btn:hover {
  color: #409eff;
}

.hidden {
  display: none;
}

* {
  margin: 0;
  padding: 0;
}

.banner {
  width: 93vw;
  height: 53vw;
  border-radius: 2vw;
  display: block;
  margin: 3vw auto;
  object-fit: cover;
  margin-bottom: 0;
}

.banner2 {
  width: 93vw;
  margin: 3vw auto;
  display: block;
  margin-bottom: 0;
  border-radius: 2vw;
}

.homebox {
  padding-bottom: 5vw;
}

.title {
  text-align: center;
  line-height: 14vw;
  font-weight: 500;
  font-size: 4vw;
  display: block;
  color: #333;
}

ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 92vw;
  margin: 0 auto 8vw;
  gap: 2vw;
}

ul li h4 {
  display: block;
  width: 100%;
  height: 6vw;
  color: #686868;
  font-weight: 400;
  line-height: 6vw;
  font-size: 3vw;
}

li {
  width: calc((100% - 4vw) / 3);
  height: 34vw;
  text-align: center;
  background: #fff;
  border-radius: 2vw;
  margin-bottom: 2vw;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
  padding-bottom: 2vw;
}

ul li img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
}

@media (min-width: 1100px) {
  .banner {
    width: 2400px;
    height: auto;
    border-radius: 20px;
    margin: 70px auto;
  }
  .banner2 {
    width: 2400px;
    margin: 70px auto;
    border-radius: 20px;
  }
  .homebox {
    padding-bottom: 50px;
  }
  .title {
    line-height: 140px;
    font-size: 60px;
  }
  ul {
    width: 2400px;
    margin: 0 auto 80px;
    gap: 40px;
  }
  ul li h4 {
    font-size: 30px;
    line-height: 110px;
    font-size: 45px;
  }
  li {
    width: calc((100% - 80px) / 3);
    height: 880px;
    border-radius: 20px;
    margin-bottom: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    overflow: hidden;
    padding-bottom: 20px;
    margin-bottom: 0;
  }
  ul li img {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
  }
}
</style>